import { createSlice } from "@reduxjs/toolkit";
import { getModels, getModelsPag } from "./thunks";
import { logOut } from "../authentication/authenticationSlice";

const initialState = {
  list: [],
  listPag: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: [],
  },
  loading: "idle",
  loadingPag: "idle",
  error: null,
};

const modelsSlice = createSlice({
  name: "models",
  initialState,
  reducers: {
    clearModelsError: (state) => {
      state.error = null;
      state.loading = "idle";
    },
  },
  extraReducers: {
    [getModels.pending]: (state) => {
      state.loading = "loading";
      state.error = null;
    },
    [getModels.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.list = action.payload;
    },
    [getModels.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [getModelsPag.pending]: (state) => {
      state.loading = "loadingPag";
      state.error = null;
    },
    [getModelsPag.fulfilled]: (state, action) => {
      state.loadingPag = "succeeded";
      state.listPag.elements = action.payload.elements;
      state.listPag.pageIndex = action.payload.pageIndex;
      state.listPag.pageSize = action.payload.pageSize;
      state.listPag.totalRecords = action.payload.totalRecords;
      state.listPag.totalPages = action.payload.totalPages;
      state.listPag.hasPreviousPage = action.payload.hasPreviousPage;
      state.listPag.hasNextPage = action.payload.hasNextPage;
    },
    [getModelsPag.rejected]: (state, action) => {
      state.loadingPag = "failed";
      state.error = action.error.message;
    },
    [logOut]: (state) => initialState,
  },
});

export const { clearBrandModelsError } = modelsSlice.actions;
export default modelsSlice.reducer;
